var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdersMngEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.41 11.2812H23.5894C15.6592 11.2812 9.23047 17.71 9.23047 25.6402V54.3582C9.23047 62.2884 15.6592 68.7172 23.5894 68.7172H56.41C64.3402 68.7172 70.7689 62.2884 70.7689 54.3582V25.6402C70.7689 17.71 64.3402 11.2812 56.41 11.2812Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6406 31.7962C25.6406 28.7193 27.6919 26.668 30.7688 26.668H49.2304C52.3073 26.668 54.3586 28.7193 54.3586 31.7962V54.3603C54.3586 57.4372 52.3073 59.4885 49.2304 59.4885H30.7688C27.6919 59.4885 25.6406 57.4372 25.6406 54.3603V31.7962Z",
    fill: "#4F7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 30.7676C32.8203 25.6394 35.8972 22.5625 39.9998 22.5625C44.1024 22.5625 47.1793 25.6394 47.1793 30.7676",
    stroke: "#7FA3FF",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 38.9727H47.1793",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 46.1523H44.1024",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 53.332H41.0254",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4886 63.5904C64.5866 63.5904 68.7193 59.4577 68.7193 54.3597C68.7193 49.2617 64.5866 45.1289 59.4886 45.1289C54.3906 45.1289 50.2578 49.2617 50.2578 54.3597C50.2578 59.4577 54.3906 63.5904 59.4886 63.5904Z",
    fill: "#F4F6FB",
    stroke: "#D9DFEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4876 59.4869C62.3198 59.4869 64.6158 57.1909 64.6158 54.3587C64.6158 51.5264 62.3198 49.2305 59.4876 49.2305C56.6554 49.2305 54.3594 51.5264 54.3594 54.3587C54.3594 57.1909 56.6554 59.4869 59.4876 59.4869Z",
    stroke: "#6B7895"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8984 50.7695L63.0779 57.949",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersMngEmptyState);
export default __webpack_public_path__ + "static/media/orders_mng_empty_state.8d7146cb7bd3d0f6981264a117ad879a.svg";
export { ForwardRef as ReactComponent };